import { EnvCtx } from "@mirage/service-environment-context/global-env-ctx";
import { isEsvConfig } from "@mirage/shared/util/esv";

/**
 * Detects if the code is running in browser extension environment.
 * This utility can be used to conditionally import or use features that are not available in extensions.
 */
export const isExtensionEnvironment = (): boolean => {
  return !!(
    (typeof browser !== "undefined" && browser?.runtime?.getURL) ||
    (typeof chrome !== "undefined" && chrome?.runtime?.getURL)
  );
};

/**
 * Detects if the code is running in a web/desktop environment (not extension).
 */
export const isWebOrDesktopEnvironment = (): boolean => {
  return !isExtensionEnvironment();
};

/**
 * Detects if the code is running in a iframe from Dropbox.com as embedded Dash web.
 */
export const isDashEmbeddedWeb = (): boolean => {
  return EnvCtx.dashExperience === "dash_embedded" && EnvCtx.surface === "web";
};

/**
 * Detects if the code is running as a standalone webapp such as dash.ai
 */
export const isDashStandaloneWeb = (): boolean => {
  return EnvCtx.dashExperience === "dash_native" && EnvCtx.surface === "web";
};

/**
 * Detects if the code is running inside Dropbox desktop app as embedded Dash.
 */
export const isDashEmbeddedDesktop = (): boolean => {
  return isEsvConfig();
};

/**
 * Detects if the code is running as Dash desktop (electron) app.
 */
export const isDashStandaloneDesktop = (): boolean => {
  return (
    EnvCtx.dashExperience === "dash_native" && EnvCtx.surface === "desktop"
  );
};
